export const MAIL_TO_PREFIX = "mailto:";

export const isMailToHref = (href?: string): boolean => {
  return href?.startsWith(MAIL_TO_PREFIX) ?? false;
};
